var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"url":_vm.api.ACTIONS.EMPLOYMENT_TYPE,"title":"EmploymentTypes","titles":_vm.titles,"input-types-add":{
                 job_type: {items: ['FULL', 'PART'],clearable: true}
            },"fields-extra-add":_vm.fieldsExtraAdd,"formatter":_vm.formatter,"actions-extra-main":_vm.actionsExtraMain,"fields-hidden-main":['updated_at','created_at'],"fields-hidden-add":['id','updated_at','created_at'],"fields-disabled-edit":['id','updated_at','created_at']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }